import { CustomerChatGateway } from './customer-chat-gateway.interface';

export const initCustomerChatAPI = (
  apiSlice: any,
  gateway: CustomerChatGateway
) => {
  apiSlice
    .enhanceEndpoints({
      addTagTypes: ['CustomerCustomerChat'],
    })
    .injectEndpoints({
      endpoints: (builder: any) => ({
        getCustomerChat: builder.query({
          query: gateway.getChatByProject,
          providesTags: ['CustomerCustomerChat'],
        }),
        postCustomerChatMessage: builder.mutation({
          query: gateway.postMessage,
          invalidatesTags: ['CustomerCustomerChat'],
        }),
        deleteCustomerChatMessage: builder.mutation({
          query: gateway.deleteMessage,
          invalidatesTags: ['CustomerCustomerChat'],
        }),
      }),
      overrideExisting: false,
    });
};

export interface CustomerChatSliceType {
  useGetCustomerChatQuery: Function;
  useLazyGetCustomerChatQuery: Function;
  usePostCustomerChatMessageMutation: Function;
  useDeleteCustomerChatMessageMutation: Function;
}
